import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const chartIcon: SvgIconData = {
  viewBox: '11.7 19.4 76.6 61.2',
  element: (
    <path d="M23.3 58.5A2.4 2.4 0 0 0 21 61v9a2.4 2.4 0 0 0 2.3 2.4h7c1.3 0 2.4-1 2.4-2.4v-9c0-1.3-1-2.4-2.4-2.4zm53.2-30.8a2.4 2.4 0 0 0-2.4 2.4v39.8a2.4 2.4 0 0 0 2.4 2.4h7c1.3 0 2.4-1 2.4-2.4V30.1c0-1.3-1.1-2.4-2.4-2.4zM41 37.5a2.4 2.4 0 0 0-2.4 2.4v30a2.4 2.4 0 0 0 2.4 2.4h7q2.1-.2 2.3-2.4v-30c0-1.3-1-2.4-2.3-2.4zM58.8 43a2.4 2.4 0 0 0-2.4 2.4v24.5a2.4 2.4 0 0 0 2.4 2.4h7q2.1-.2 2.3-2.4V45.4c0-1.3-1-2.4-2.3-2.4zM14 19.4c-1.3 0-2.4 1-2.4 2.4v56.4c0 1.3 1 2.4 2.4 2.4h71.8a2.4 2.4 0 1 0 0-4.7H16.4V21.8c0-1.3-1-2.4-2.3-2.4" />
  ),
};
